import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";
import {EWASTE_API_PATHS, HTTP_METHOD, PROCESS_NAME} from "../constants/EWasteApiPaths";

const metricProcessName = "SCC_EWASTE_CONTAINER_CLOSE";
const SUB_PROCESS = "closeEWasteContainer";

/**
 * Calls OculusService.CloseEWasteContainer via Boson FlowApiGateway.
 *
 * @param {string} containerId Container UUID.
 * @param {string} locale Locale string (e.g. "en_GB", "de_DE"). Required by WADM.
 * @returns {Promise<{success: boolean, data?: Object}>}
 */
export async function closeEWasteContainer(containerId, locale) {
    const startTime = Date.now();
    const request = {
        resourcePath: EWASTE_API_PATHS.CLOSE_CONTAINER,
        httpMethod: HTTP_METHOD.POST,
        processName: PROCESS_NAME.OCULUS,
        requestBody: {
            containerId,
            locale
        }
    };

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, true);
            return {success: true, data: response.data};
        }
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false};
    } catch (error) {
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false};
    }
}



// WEBPACK FOOTER //
// ./src/commons/api/CloseEWasteContainer.js